import React from 'react';
import { Dumbbell, Brain, Rocket } from 'lucide-react';

interface DifficultySelectorProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function DifficultySelector({ value, onChange, className = '' }: DifficultySelectorProps) {
  const difficulties = [
    {
      value: 'easy',
      label: 'Easy',
      icon: Dumbbell,
      description: 'Start with basic tasks',
      color: 'bg-green-50 text-green-600 hover:bg-green-100'
    },
    {
      value: 'medium',
      label: 'Medium',
      icon: Brain,
      description: 'Balanced challenge',
      color: 'bg-blue-50 text-blue-600 hover:bg-blue-100'
    },
    {
      value: 'hard',
      label: 'Hard',
      icon: Rocket,
      description: 'Advanced intensity',
      color: 'bg-purple-50 text-purple-600 hover:bg-purple-100'
    }
  ];

  return (
    <div className={`space-y-2 ${className}`}>
      <label className="block text-sm font-medium text-gray-600">
        Difficulty Level
      </label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {difficulties.map((difficulty) => (
          <button
            key={difficulty.value}
            type="button"
            onClick={() => onChange(difficulty.value)}
            className={`p-4 rounded-xl transition-all ${
              value === difficulty.value
                ? `ring-2 ring-offset-2 ${difficulty.color.replace('hover:', '')}`
                : `${difficulty.color} opacity-70`
            }`}
          >
            <difficulty.icon className="w-6 h-6 mb-2" />
            <div className="font-medium">{difficulty.label}</div>
            <div className="text-sm opacity-80">{difficulty.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
}